module Meevo.Plugins.AppointmentBook {
    import StepOverrideStageEnum = Model.StepOverrideStageEnum;

    export interface ICalculateStepDurationRequest {
        serviceAddOns: any[];
        steps: any[];
        durationInMinutes: number;
        extendedByStepMinutes?: number;
        durationWithAddOnsInMinutes?: number;
    }

    export class StepOverride {
        static $inject = [
            "meevo.components.modal.ModalService",
            "meevo.components.common.DataService",
            "$q",
        ];

        constructor(
            protected modalService: Meevo.Components.Modal.IModalService,
            protected dataService: Meevo.Components.Common.ICommonDataService,
            protected $q: angular.IQService
        ) {
        }

        check(entity, client) {
            if (!entity.isEnableIntelliBooking || !client || !client.id) {
                return this.$q.resolve();
            }

            let proceed = false;
            entity.steps.forEach(step => {
                if (step.durationInMinutes !== step.previousDurationInMinutes) {
                    proceed = true;
                }
                step.previousDurationInMinutes = step.durationInMinutes;
            });

            // Nothing has changed
            if (!proceed) {
                return this.$q.resolve();
            }

            if ((entity.stepOverrideStage === StepOverrideStageEnum.Add ||
                 entity.stepOverrideStage === StepOverrideStageEnum.Existing ||
                 entity.stepOverrideStage === StepOverrideStageEnum.Update) &&
                _(entity.steps).all(step => step.durationInMinutes === step.defaultDurationInMinutes)) {
                return this.modalService.confirmHandler("MESSAGE_CLIENT_BOOKING_PREFERENCES_REMOVE").then((result) => {
                    if (result) {
                        entity.stepOverrideStage = entity.stepOverrideStage === StepOverrideStageEnum.Existing || entity.stepOverrideStage === StepOverrideStageEnum.Update
                            ? StepOverrideStageEnum.Remove
                            : StepOverrideStageEnum.None;
                    }
                });
            }
            else if (_(entity.steps).any(step => step.durationInMinutes !== step.defaultDurationInMinutes)) {
                return this.modalService.confirmHandler("MESSAGE_CLIENT_BOOKING_PREFERENCES_ADD").then((result) => {
                    if (result) {
                        entity.stepOverrideStage = entity.stepOverrideStage === StepOverrideStageEnum.None
                            ? StepOverrideStageEnum.Add
                            : StepOverrideStageEnum.Update;
                    } else {
                        entity.stepOverrideStage = entity.stepOverrideStage === StepOverrideStageEnum.Update
                            ? StepOverrideStageEnum.Existing
                            : StepOverrideStageEnum.None;
                    }
                });
            }

            return this.$q.resolve();
        }

        initialize(entity, client) {
            if (!client || !client.id) {
                return this.$q.resolve();
            }

            // load default duration or actual steps if steps don't exist on entity as could be the case for waitlist service
            if (angular.isUndefined(entity.stepOverrideStage)) {
                const request = {
                    ServiceId: entity.serviceId,
                    EmployeeId: entity.employeeId,
                    ServiceAddOnIds: null,
                    clientId: client.id
                };

                return this.dataService.customMethodData(`/api/appointmentservice/template`, "post", request).then(response => {
                    entity.isEnableIntelliBooking = response.data.isEnableIntelliBooking;

                    if (entity.steps && entity.steps.length > 0) {
                        entity.steps.forEach(step => {
                            const matchingStep = _(response.data.steps).findWhere({ serviceStepId: step.serviceStepId });
                            step.defaultDurationInMinutes = matchingStep
                                ? matchingStep.defaultDurationInMinutes
                                : 0;
                        });
                    } else {
                        entity.steps = response.data.steps.map(step => ({
                            serviceStepId: step.serviceStepId,
                            durationInMinutes: step.durationInMinutes,
                            extendedByStepMinutes: step.extendedByStepMinutes,
                            durationWithAddOnsInMinutes: step.durationWithAddOnsInMinutes,
                            defaultDurationInMinutes: step.defaultDurationInMinutes,
                            serviceStepType: step.serviceStepType,
                            serviceStepDisplayName: step.serviceStepDisplayName,
                            serviceStepTypeDisplayName: step.serviceStepTypeDisplayName
                        }));
                        this.calculateStepDuration(entity);
                    }

                    this.initializeStage(entity);
                });
            } else {
                return this.$q.resolve();
            }
        }

        initializeStage(entity) {
            if (_(entity.steps).any(step => angular.isUndefined(step.defaultDurationInMinutes))) {
                return;
            }

            entity.steps.forEach(step => {
                step.previousDurationInMinutes = step.durationInMinutes;
            });

            entity.stepOverrideStage = _(entity.steps).any(step => step.durationInMinutes !== step.defaultDurationInMinutes)
                ? StepOverrideStageEnum.Existing
                : StepOverrideStageEnum.None;
        }

        save(entity, client, parentEntityId, noun) {
            const clientId = (client || {}).id;
            const employeeId = entity.employeeId || (entity.employee || {}).id;

            if (entity.stepOverrideStage === StepOverrideStageEnum.None ||
                entity.stepOverrideStage === StepOverrideStageEnum.Existing ||
                !entity.isEnableIntelliBooking ||
                !clientId ||
                !employeeId
            ) {
                return this.$q.resolve();
            }

            const isMinutesOverridden = _(entity.steps).any(step => step.durationInMinutes !== step.defaultDurationInMinutes);

            const request = entity.steps.map(step => ({
                id: parentEntityId,
                auditEntityId: parentEntityId,
                auditEntityEnum: noun,
                clientId: clientId,
                serviceDisplayName: entity.service.displayName,
                employeeDisplayName: entity.employee.displayName,
                model: {
                    clientId: clientId,
                    employeeId: employeeId,
                    serviceGlobalId: entity.serviceId,
                    stepId: step.serviceStepId,
                    isMinutesOverriden: isMinutesOverridden,
                    minutes: step.durationInMinutes,
                    stepType: step.serviceStepType,
                    stepTypeDisplay: step.serviceStepDisplayName,
                    stepNumber: step.serviceStepNumber
                }
            }));

            return this.dataService.patchArray("/ClientEmployeeServiceStepOverride", request);
        }

        calculateStepDuration(appointmentService: ICalculateStepDurationRequest) {
            // step durationInMinutes must be set coming into here

            _(appointmentService.steps).each(step => {
                step.extendedByStepMinutes = 0;
            });

            _(appointmentService.serviceAddOns).each(addOn => {
                const extendedByStep = _(appointmentService.steps).find(step => step.serviceStepId === addOn.extendedByStepId);
                if (extendedByStep) {
                    extendedByStep.extendedByStepMinutes += addOn.extendedByStepMinutes;
                }
            });

            // appointmentService durationInMinutes is not always set, recalculate it
            appointmentService.durationInMinutes = 0;
            appointmentService.extendedByStepMinutes = 0;

            _(appointmentService.steps).each(step => {
                appointmentService.durationInMinutes += step.durationInMinutes;
                appointmentService.extendedByStepMinutes += step.extendedByStepMinutes;

                step.durationWithAddOnsInMinutes = step.durationInMinutes + step.extendedByStepMinutes;
            });

            appointmentService.durationWithAddOnsInMinutes = appointmentService.durationInMinutes + appointmentService.extendedByStepMinutes;
        }
    }
}

angular.module("ApptBookApp")
    .service("meevo.plugins.appointmentBook.stepOverrideService", Meevo.Plugins.AppointmentBook.StepOverride);